module.exports = __webpack_public_path__ + "static/media/getatour.b9e2bfda.png";